import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 24,
    type: CHECKLIST_ITEM_TYPE.FREE_TEXT,
    manifestKey: 'FREE_TEXT',

    try_it: {
        button_label: 'Enter Free Text Response',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'FreeTextCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { text: 'Patient confirmed appointment for next Tuesday.' },
        },
    },
    pre_flight_diff: [
        'Inline text popover opens — user types free text',
        'Checklist item: PENDING → YES',
        'Text stored in response_payload.text',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'No lead status change',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
